module.exports = __webpack_public_path__ + "img/mitsu-used.b2d79c94.png";